export const COUNTRIES_PREFIX = "countries";

export const COUNTRIES_ACTIONS = {
  GET_COUNTRIES: `${COUNTRIES_PREFIX}/GET_COUNTRIES`,
} as const;
